export const IS_CLIENT_PLATFORM = typeof window !== 'undefined';
export const APP_BASE_PATH: string = process.env.REACT_APP_BASE_PATH || '';
export const SENTRY_ENV: string = process.env.REACT_APP_SENTRY_ENV || '';
export const SENTRY_DSN: string = process.env.REACT_APP_SENTRY_DSN || '';
export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const USER_EMAIL = 'USER_EMAIL';

export const PasswordInfoText = `Your password should have a minimum of 8 characters and contain at least one capital letter, small letter, special symbol and number.<br>Accepted Unicode latin letter, numbers, and special symbols: ~\`!@#$%^&amp;*()_-+= {[}]|\\:;"&lt;&gt;,./? allowed only.`;
